<template>
  <r-toggle-card
    :title="filter.field || 'Фильтр'"
    :is-open="filter.enabled"
    @toggle="toggleFilter"
  >
    <div class="map-filter-item">
      <div class="map-filter-item__container">
        <div class="map-filter-item__block">
          <r-text
            type="caption"
            v-if="!filter.field"
            style="margin-bottom: 4px;"
          >
            Выберите атрибут
          </r-text>
          <div class="map-filter-item__attribute-select">
            <simple-attributes
              :id="id"
              field="field"
              :settings="filter"
              :filter-id="filter.id"
              type="number-time-string-bool"
              :change-handler="changeFilterField"
              :multiple="false"
            />
            <el-tooltip
              :open-delay="1000"
              effect="dark"
              content="Удалить фильтр"
              placement="top"
            >
              <el-button
                size="mini"
                class="r-button icon-button small"
                type="danger"
                circle
                @click="removeFilter(filter)"
              >
                <r-icon name="trash" :size="14" />
              </el-button>
            </el-tooltip>
          </div>
        </div>

        <div class="map-filter-item__block" v-if="filter.field">
          <div class="map-filter-item__slider">
            <div class="map-filter-item__slider-title">
              <r-text type="caption">
                Значение фильтра
                <i v-if="filter.loading" class="el-icon-loading" />
              </r-text>
            </div>
            <div
              class="map-filter-item__value-container"
              v-if="
                filter.fieldType === 'string' || filter.fieldType === 'boolean'
              "
            >
              <div class="map-filter-item__strings-values">
                <el-select
                  class="r-select dark"
                  @change="changeFilter"
                  placeholder="Выберите значения"
                  v-model="filter.values"
                  multiple
                  clearable
                  popper-class="r-select__popper dark"
                  collapse-tags
                >
                  <el-option
                    v-for="item in filter.allValues"
                    :key="item.value"
                    :label="String(item.value)"
                    :value="item.value"
                    class="map-filter-item__option"
                  >
                    <span style="float: left;">{{ item.value }}</span>
                    <span
                      style="float: right; color: #8492a6; font-size: 11px;"
                    >
                      {{ item.count }}
                    </span>
                  </el-option>
                </el-select>
              </div>
              <div class="map-filter-item__operation">
                <r-text type="caption">
                  Тип операции
                </r-text>
                <el-select
                  class="r-select dark"
                  @change="changeFilter"
                  v-model="filter.operation"
                  popper-class="r-select__popper dark"
                >
                  <el-option
                    v-for="item in operations"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="map-filter-item__value-container" v-else>
              <div
                class="map-filter-item__slider-actions"
                v-if="filter.fieldType === 'datetime'"
              >
                <el-tooltip
                  :open-delay="500"
                  effect="dark"
                  content="Включить машину времени"
                  placement="bottom"
                  v-if="hasTimeMachine"
                >
                  <el-button
                    class="r-button small"
                    size="mini"
                    type="primary"
                    icon="el-icon-time"
                    circle
                    @click="changeTimemachineState(filter)"
                  />
                </el-tooltip>
              </div>
              <distribution-diagram
                :slider="filter.range"
                :max="filter.max"
                :min="filter.min"
                :all-count="filter.allCount"
                :chunks="filter.chunks"
              />
              <div class="map-filter-item__slider-block full-width">
                <el-slider
                  class="r-slider dark square"
                  range
                  :min="filter.min"
                  :max="filter.max"
                  :step="1"
                  :format-tooltip="
                    filter.fieldType === 'number'
                      ? parseTooltipValue
                      : parseTooltipTimeValue
                  "
                  @change="changeFilter(filter.filterId)"
                  v-model="filter.range"
                />
              </div>
              <div
                class="map-filter-item__slider-inputs"
                v-if="filter.fieldType === 'number'"
              >
                <el-input-number
                  :controls="false"
                  class="r-input dark"
                  size="mini"
                  type="number"
                  @change="changeFilter(filter.id)"
                  v-model="filter.range[0]"
                />
                <r-text type="caption">
                  -
                </r-text>
                <el-input-number
                  :controls="false"
                  class="r-input dark"
                  size="mini"
                  type="number"
                  @change="changeFilter(filter.id)"
                  v-model="filter.range[1]"
                />
              </div>
              <div class="map-filter-item__slider-time-row" v-else>
                <div class="map-filter-item__slider-time-item">
                  <r-text type="caption">
                    {{ parseTimeValue(filter.min) }}
                  </r-text>
                </div>
                <div class="map-filter-item__slider-time-item">
                  <r-text type="caption">
                    {{ parseTimeValue(filter.max) }}
                  </r-text>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </r-toggle-card>
</template>

<script>
import moment from "moment";
import DistributionDiagram from "../../distribution-diagram/distribution-diagram";
import SimpleAttributes from "../../simple-attributes/simple-attributes";

const operations = [
  { value: "in", label: "Равно" },
  { value: "!in", label: "Не равно" }
];

export default {
  props: ["id", "filter", "layer-controller"],
  data() {
    return {
      operations
    };
  },
  components: {
    SimpleAttributes,
    DistributionDiagram
  },
  computed: {
    hasTimeMachine() {
      return this.$store.getters.hasInstrument("Map", "Time Machine");
    }
  },
  methods: {
    removeFilter(filter) {
      const { field } = filter;
      this.$emit("remove-filter", filter);
      if (field) this.changeFilter();
    },
    toggleFilter(value) {
      this.filter.enabled = value;

      this.changeFilter();
    },
    changeFilter() {
      this.layerController.handlers[this.id]("filters");
    },
    async changeFilterField(id, value) {
      if (value) this.layerController.changeFilterField(this.filter, id, value);
      this.changeFilter();
    },
    parseTimeValue(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    parseTooltipTimeValue(value) {
      return moment(value).format("YYYY-MM-DD HH:MM");
    },
    parseTooltipValue(value) {
      return value;
    },
    parseFullValue({ fieldType, range }) {
      if (!this.filter.field) return "Отсутствует";
      return fieldType === "number"
        ? `${range[0]} - ${range[1]}`
        : `${this.parseTooltipTimeValue(
            range[0]
          )} - ${this.parseTooltipTimeValue(range[1])}`;
    },
    changeTimemachineState(filter) {
      this.layerController.map.changeTimemachineState(filter);
    }
  }
};
</script>

<style lang="scss">
.map-filter-item {
  &:not(:first-child) {
    margin-top: 20px;
  }

  &__subheader {
    background-color: var(--field_bg) !important;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-left: 3px solid;
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
    border-left-color: var(--dividers_low_contrast) !important;

    &.datetime {
      border-color: #ff4c8d;
    }
    &.number {
      border-color: #1e98f0;
    }
    &.string {
      border-color: #f8c348;
    }
    &.boolean {
      border-color: #00b65c;
    }

    &-title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 5px;

      .small {
        font-weight: normal;
      }
    }
    &-subtitle {
      font-style: italic;
      font-size: 11px;
    }

    &-actions {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: space-between;
    }

    &-close {
      width: 24px;
      height: 24px;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  &__attribute-select {
    display: flex;
    align-items: center;

    .r-button {
      margin-left: 16px;
    }
  }

  &__block:not(:first-child) {
    margin-top: 10px;
  }
  &__title {
    margin-bottom: 5px;
  }

  .r-select.el-select {
    width: 100%;
  }

  &__strings-values {
    margin-top: 5px;

    .el-tag {
      display: flex;
      align-items: center;
    }

    .el-select__tags-text {
      max-width: 68px;
      text-overflow: ellipsis;
      display: inline-block;
      overflow: hidden;
    }
  }

  &__option {
    &-text {
      max-width: 320px;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inline-block;
      margin-right: 24px;
    }

    &.selected {
      .map-filter-item__option-count {
        color: #fff !important;
      }
    }

    &:after {
      display: none;
    }
  }

  &__operation {
    margin-top: 16px;

    .r-text {
      margin-bottom: 4px;
    }

    .r-select {
      width: 50%;
      .el-input__inner {
        font-size: 11px;
        line-height: 28px;
        height: 28px;
      }
      .el-input__icon {
        line-height: 28px;
        font-size: 11px !important;
      }
    }
  }

  &__slider {
    position: relative;

    &.top {
      margin-top: 10px;
    }

    &-title {
      vertical-align: middle;
    }

    &-block {
      padding: 0 10px !important;
      width: 75%;

      &.full-width {
        width: 100%;
        box-sizing: border-box;
      }
    }
    &-container {
      display: flex;
      align-items: center;
    }
    .r-input {
      width: 30% !important;
    }

    &-inputs {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .r-input {
        width: 45% !important;
        .el-input__inner {
          height: 24px;
          line-height: 24px;
        }
      }
    }
    &-time {
      &-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      &-item {
        font-size: 10px;
        color: rgba(var(--white_white), 0.6);
      }
    }

    &-actions {
      position: absolute;
      top: 0;
      right: 0;

      .r-button.small {
        padding: 2px !important;
      }
    }
  }
}
</style>
